// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/slick-carousel/slick/slick.css
 ** module id = 473
 ** module chunks = 1
 **/